import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';

export const ACTIVE_ENTERPRISE_COOKIE_NAME = 'activeCompanyId';

type ActiveContextState = {
  activeEnterpriseId: string | null;
};

const initialState: ActiveContextState = {
  activeEnterpriseId: Cookies.get(ACTIVE_ENTERPRISE_COOKIE_NAME) ?? null,
};

const activeContextSlice = createSlice({
  name: 'activeContext',
  initialState,
  reducers: {
    setActiveEnterpriseId(state, action: PayloadAction<string>) {
      const newActiveEnterpriseId = action.payload;
      Cookies.set(ACTIVE_ENTERPRISE_COOKIE_NAME, newActiveEnterpriseId, {
        expires: 7,
      });
      state.activeEnterpriseId = newActiveEnterpriseId;
    },
    clearActiveEnterpriseId(state) {
      Cookies.remove(ACTIVE_ENTERPRISE_COOKIE_NAME);
      state.activeEnterpriseId = null;
    },
  },
});

export const { setActiveEnterpriseId, clearActiveEnterpriseId } =
  activeContextSlice.actions;

export default activeContextSlice.reducer;
